export default __webpack_public_path__ + "static/project-management-en-c84785d9498bd67a5456079311e1e441.webp";